import { useState } from "react";
import {
  ArrowDownload20Regular,
  DocumentPdf20Regular,
} from "@fluentui/react-icons";

interface WorkMapExportButtonsProps {
  onExportExcel: () => Promise<void>;
  onExportPdf: () => Promise<void>;
}

// Botões de exportação dos mapas [4.2.4]: Excel + PDF, alinhados à direita por
// cima da barra de resumo. Estado de carregamento por botão; erro inline.
export function WorkMapExportButtons({
  onExportExcel,
  onExportPdf,
}: WorkMapExportButtonsProps) {
  const [busy, setBusy] = useState<"excel" | "pdf" | null>(null);
  const [failed, setFailed] = useState(false);

  const run = async (kind: "excel" | "pdf", fn: () => Promise<void>) => {
    setBusy(kind);
    setFailed(false);
    try {
      await fn();
    } catch {
      setFailed(true);
    } finally {
      setBusy(null);
    }
  };

  const buttonClass =
    "px-3 py-2 bg-secondary hover:bg-accent border border-border transition-colors flex items-center gap-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex gap-2">
        <button
          type="button"
          className={buttonClass}
          style={{ borderRadius: "var(--radius-button)" }}
          onClick={() => {
            void run("excel", onExportExcel);
          }}
          disabled={busy !== null}
          title="Exportar mapa para Excel"
        >
          <ArrowDownload20Regular className="w-5 h-5" />
          {busy === "excel" ? "A exportar..." : "Excel"}
        </button>
        <button
          type="button"
          className={buttonClass}
          style={{ borderRadius: "var(--radius-button)" }}
          onClick={() => {
            void run("pdf", onExportPdf);
          }}
          disabled={busy !== null}
          title="Exportar mapa para PDF"
        >
          <DocumentPdf20Regular className="w-5 h-5" />
          {busy === "pdf" ? "A exportar..." : "PDF"}
        </button>
      </div>
      {failed && (
        <span className="text-destructive text-xs">
          Não foi possível exportar. Tente novamente.
        </span>
      )}
    </div>
  );
}
